// ChatbotContext.tsx
import { createContext, useContext, useState, ReactNode } from 'react';

const ChatbotContext = createContext<{
  isVisible: boolean;
  toggleChatbot: () => void;
  showChatbot: () => void;
  hideChatbot: () => void;
}>({
  isVisible: false,
  toggleChatbot: () => {},
  showChatbot: () => {},
  hideChatbot: () => {},
});

export const ChatbotProvider = ({ children }: { children: ReactNode }) => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleChatbot = () => setIsVisible(prev => !prev);
  const showChatbot = () => setIsVisible(true);
  const hideChatbot = () => setIsVisible(false);

  return (
    <ChatbotContext.Provider value={{ isVisible, toggleChatbot, showChatbot, hideChatbot }}>
      {children}
    </ChatbotContext.Provider>
  );
};

export const useChatbot = () => useContext(ChatbotContext);
